export const CATALOGUE_PAGE_SIZES = [12, 24, 48];
export const DEFAULT_CATALOGUE_PAGE_SIZE = 12;

export const cataloguePageSize = (value) => {
  const parsed = parseInt(value, 10);
  return CATALOGUE_PAGE_SIZES.includes(parsed) ? parsed : DEFAULT_CATALOGUE_PAGE_SIZE;
};

export const cataloguePageIndex = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

export const buildCourseCatalogueQuery = ({
  pageno = 0,
  perpage = DEFAULT_CATALOGUE_PAGE_SIZE,
  category = '',
  search = '',
} = {}) => {
  const query = new URLSearchParams();
  query.set('pageno', String(cataloguePageIndex(pageno)));
  query.set('perpage', String(cataloguePageSize(perpage)));
  const categoryName = String(category || '').trim();
  const searchText = String(search || '').trim();
  if (categoryName) {
    query.set('category', categoryName);
  }
  if (searchText) {
    query.set('search', searchText);
  }
  return query.toString();
};

export const emptyCataloguePagination = (perpage = DEFAULT_CATALOGUE_PAGE_SIZE) => ({
  pageno: 0,
  perpage: cataloguePageSize(perpage),
  data_count: 0,
  total_pages: 0,
  has_next: false,
  has_previous: false,
});

export const resolveCataloguePagination = (
  pagination,
  { pageno = 0, perpage = DEFAULT_CATALOGUE_PAGE_SIZE, courses = [] } = {}
) => {
  const requestedPage = cataloguePageIndex(pageno);
  const requestedSize = cataloguePageSize(perpage);
  if (pagination && typeof pagination === 'object') {
    const pageSize = cataloguePageSize(pagination.perpage ?? requestedSize);
    const pageIndex = cataloguePageIndex(pagination.pageno ?? requestedPage);
    const parsedCount = Number(pagination.data_count);
    const dataCount = Number.isFinite(parsedCount) ? parsedCount : courses.length;
    const parsedPages = Number(pagination.total_pages);
    const totalPages = Number.isFinite(parsedPages)
      ? parsedPages
      : (dataCount > 0 ? Math.ceil(dataCount / pageSize) : 0);
    return {
      pageno: pageIndex,
      perpage: pageSize,
      data_count: dataCount,
      total_pages: totalPages,
      has_next: pagination.has_next != null ? !!pagination.has_next : pageIndex + 1 < totalPages,
      has_previous: pagination.has_previous != null ? !!pagination.has_previous : pageIndex > 0,
    };
  }
  return {
    ...emptyCataloguePagination(requestedSize),
    pageno: requestedPage,
    data_count: courses.length,
    total_pages: courses.length > 0 ? 1 : 0,
  };
};

export const catalogueCoursesFromResponse = (response) => {
  if (Array.isArray(response?.courses)) {
    return response.courses;
  }
  if (!Array.isArray(response?.data)) {
    return [];
  }
  return response.data.flatMap((group) => (
    Array.isArray(group?.courses) ? group.courses : []
  ));
};

export const catalogueCategoriesFromResponse = (response) => {
  if (Array.isArray(response?.filters?.categories)) {
    return response.filters.categories.filter((name) => typeof name === 'string' && name.trim());
  }
  if (!Array.isArray(response?.data)) {
    return [];
  }
  return response.data
    .map((group) => group?.category)
    .filter((name) => typeof name === 'string' && name.trim());
};
